// extracted by mini-css-extract-plugin
export default {"Box":"tokenized-filter-input-module__Box--w5A7b","Box_1":"tokenized-filter-input-module__Box_1--EFtXe","Octicon":"tokenized-filter-input-module__Octicon--txjXz"};